/**
 * Analytics hook - fires events across GA, Meta, Reddit, X.
 * All four pixel scripts are initialized in index.html.
 */
export const useAnalytics = () => {
  const track = (eventName, params = {}) => {
    try {
      // Google Analytics (gtag)
      if (window.gtag) {
        window.gtag('event', eventName, params);
      }
      // Meta Pixel (fbq)
      if (window.fbq) {
        window.fbq('trackCustom', eventName, params);
      }
      // Reddit Pixel (rdt)
      if (window.rdt) {
        window.rdt('track', eventName);
      }
      // X / Twitter Pixel (twq)
      if (window.twq) {
        window.twq('event', eventName, params);
      }
    } catch (e) {
      /* silent - tracking should never break the app */
    }
  };

  const trackLead = (source = 'waitlist') => {
    try {
      if (window.gtag) window.gtag('event', 'generate_lead', { event_category: 'engagement', event_label: source });
      if (window.fbq) window.fbq('track', 'Lead', { content_name: source });
      if (window.rdt) window.rdt('track', 'Lead');
      if (window.twq) window.twq('event', 'tw-r7a17-or7a1', {});
    } catch (e) { /* silent */ }
  };

  const trackPurchaseIntent = (tier, price) => {
    try {
      if (window.gtag) window.gtag('event', 'begin_checkout', { currency: 'EUR', value: price, items: [{ item_name: tier }] });
      if (window.fbq) window.fbq('track', 'InitiateCheckout', { content_name: tier, currency: 'EUR', value: price });
      if (window.rdt) window.rdt('track', 'AddToCart');
      if (window.twq) window.twq('event', 'tw-r7a17-or7a3', {});
    } catch (e) { /* silent */ }
  };

  const trackShare = (platform) => {
    try {
      if (window.gtag) window.gtag('event', 'share', { method: platform, content_type: 'page' });
      if (window.fbq) window.fbq('trackCustom', 'Share', { platform });
      if (window.rdt) window.rdt('track', 'Custom', { customEventName: 'Share' });
      if (window.twq) window.twq('event', 'tw-r7a17-or7a5', {});
    } catch (e) { /* silent */ }
  };

  const trackSignup = () => {
    try {
      if (window.gtag) window.gtag('event', 'sign_up', { method: 'email' });
      if (window.fbq) window.fbq('track', 'CompleteRegistration');
      if (window.rdt) window.rdt('track', 'SignUp');
      if (window.twq) window.twq('event', 'tw-r7a17-or7a2', {});
    } catch (e) { /* silent */ }
  };

  return { track, trackLead, trackPurchaseIntent, trackShare, trackSignup };
};
